import { forwardRef, createElement } from 'react';

function IconPlay(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM9.8 8a.7.7 0 011.05-.606l.084.057 4.86 3.84a.7.7 0 01.081 1.023l-.081.075-4.86 3.84a.7.7 0 01-1.127-.449l-.007-.1V8zm1.4 1.445v4.789l3.03-2.395-3.03-2.394z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Play = /*#__PURE__*/forwardRef(IconPlay);

export default Play;
//# sourceMappingURL=Play.js.map
